<template>
    <div class="item" :class="{'is-advanced': location.isSelfBuy || location.isInsulation || (location.vat && location.vat.length)}">
        <div class="note" v-show="location.note">
            <div class="icon">
                <img src="@/assets/img/enter.svg">
            </div>
            <div class="content">{{ location.note }}</div>
        </div>
        <div v-show="location.products">
            <div class="products">
                <div v-for="(product, index) in location.products" :key="index" @click.stop="openProduct(index, product)">
                    <div class="divider" v-show="index > 0"/>
                    <div class="product" >
                        <div class="product-content">
                            <div class="product-title">
                                <span>x {{ product.count }}</span>{{ product.name }}
                            </div>
                            <div class="product-info">
                                {{ product.options | OptionsToString }}
                            </div>
                        </div>
                        <div class="product-price">
                            $ {{ product.is_elastic ? '依店內價格' : product.sumPrice * product.count }}
                        </div>
                    </div>
                    <div class="product-note" v-show="product.note">
                        <div class="product-icon">
                            <img src="@/assets/img/enter.svg">
                        </div>
                        <div class="product-content">{{ product.note }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="advanced" v-show="location.isSelfBuy || location.isInsulation || (location.vat && location.vat.length)">
            <div class="advanced-item" v-show="location.isSelfBuy">
                <img src="@/assets/img/ordered-green.svg">
                已訂購
            </div>
            <div class="advanced-item" v-show="location.isInsulation">
                <img src="@/assets/img/insulation-green.svg">
                需保溫
            </div>
            <div class="advanced-item" v-show="location.vat && location.vat.length">
                <img src="@/assets/img/vat-green.svg">
                統編 {{ location.vat }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LiquorItem',
        props: {
            location: {
                default: Object,
                required: true,
            },
        },
        methods: {
            openProduct(index, product) {
                this.$emit('openProduct', {
                    key: this.$vnode.key,
                    index: index,
                    product: product,
                });
            },
        },
        filters: {
            OptionsToString(options) {
                return options.map(option => option.name).join(', ');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .item {
        border: none;
        border-radius: 5px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
        text-align: left;
        margin: 10px 15px;
        padding: 10px;
        position: relative;

        &.is-advanced {
            margin: 20px 15px;
        }

        .line {
            border: solid 2px white;
            position: absolute;
            width: 63px;
            bottom: -2px;
            left: 6px;
        }

        .note {
            display: flex;
            align-items: baseline;

            .icon {
                flex: 0;
            }

            .content {
                white-space: pre-line;
                color: #9B9B9B;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                word-break: break-all;
            }
        }

        .divider {
            width: inherit;
            margin: 10px 10px;
            border-bottom: solid 1px #DDDDDD;
        }

        .advanced {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #339933;
            line-height: 20px;
            box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
            margin: 10px -10px -20px -10px;
            background-color: #FFFFFF;
            border-radius: 0 0 20px 20px;
            padding: 10px;
            user-select: none;
            cursor: pointer;

            .advanced-item {
                display: flex;
                align-items: center;
                justify-content: center;

                &:not(:last-child) {
                    margin-right: 5px;
                }
            }
        }

        .products {
            margin-top: 10px;

            .product-note {
                display: flex;
                align-items: baseline;
                margin-left: 16px;

                .product-icon {
                    flex: 0;
                }

                .product-content {
                    white-space: pre-line;
                    color: #9B9B9B;
                    font-size: 12px;
                    letter-spacing: 0;
                    line-height: 17px;
                }
            }

            .product {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 10px;

                .product-price {
                    color: #339933;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                }

                .product-content {
                    .product-title {
                        color: #9B9B9B;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 20px;

                        span {
                            color: #339933;
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 20px;
                            margin-right: 10px;
                        }
                    }

                    .product-info {
                        color: #9B9B9B;
                        font-size: 12px;
                        letter-spacing: 0;
                        line-height: 17px;
                        margin-top: 5px;

                        span {
                            color: #339933;
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 20px;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }
</style>
